import logoutpng0 from '../../../assets/images/logout.png';

import React, { useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import { makeStyles, withStyles ,useTheme } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import Collapse from "@material-ui/core/Collapse";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import List from "@material-ui/core/List";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Divider from "@material-ui/core/Divider";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import Box from "@material-ui/core/Box";
import Typography  from "@material-ui/core/Typography";
import Drawer from "@material-ui/core/Drawer";
import LoginButton from "../Login/loginButton";
import { devConsolelog, WebContext } from "../../../Utility";

import Phone from "@material-ui/icons/Phone";
import Email from "@material-ui/icons/Email";

const useStylesMobile = makeStyles((theme) => ({
  iconStyle: {
    marginRight: theme.spacing(1),
    color: theme.agentTheme.card.foreground,
    display: "flex",
    alignItems: "center",
  },
}));

const getMobileNavItem = (
  classes,
  username,
  contentArr,
  location,
  handleListItemClick,
  theme
) => {
  return (
    <List component="div" aria-labelledby="nested-list-subheader">
      {contentArr.map((item) => {
        let showActive = false;
        if (location.pathname == item.link) showActive = true;
        else if (location.pathname == "/" && item.link == `/${username}`)
          showActive = true;
        else if (item.clickHandle) {
          item.clickItem.map((element) => {
            devConsolelog("item show active", element, location.pathname, item);
            if (
              element.link == location.pathname ||
              element.link.pathname == location.pathname
            )
              showActive = true;
          });
        }
        if (item.clickHandle) {
          return (
            <MobileDropdownItems
              location={location}
              item={item}
              theme={theme}
              showActive={showActive}
              handleListItemClick={handleListItemClick}
            />
          );
        } else {
          return (
            <>
              <ListItem
                button
                className={`${classes.navTextHoverMobile} ${
                  classes.navBarTextContainer
                } ${
                  showActive
                    ? classes.activeNavItem
                    : classes.inActiveMobileItem
                } `}
                onClick={() => handleListItemClick(item)}
              >
                <ListItemText
                  primary={item.label}
                  style={{ color: theme?.agentTheme?.background?.primary_text }}
                />
              </ListItem>
            </>
          );
        }
      })}
    </List>
  );
};

const MobileDropdownItems = ({
  location,
  item = {},
  showActive = false,
  handleListItemClick,
  theme,
}) => {
  const classes = useStylesMobile();
  const [dropdownOpen, setDropdownOpen] = useState(true);

  return (
    <>
      <ListItem button onClick={() => setDropdownOpen(!dropdownOpen)}>
        <ListItemText
          primary={item.label}
          style={{ color: theme?.agentTheme?.background?.primary_text }}
        />
        {dropdownOpen ? (
          <ExpandLess
            style={{ color: theme?.agentTheme?.background?.primary_text }}
          />
        ) : (
          <ExpandMore
            style={{ color: theme?.agentTheme?.background?.primary_text }}
          />
        )}
      </ListItem>
      <Divider
        style={{
          backgroundColor: theme?.agentTheme?.background?.primary_text,
          opacity: 0.5,
        }}
      />
      <Collapse
        in={dropdownOpen}
        timeout="auto"
        unmountOnExit
        className={classes.listItemCollapse}
      >
        <List component="div">
          {item.clickItem.map((element, idx) => {
            let showActiveSub = false;
            if (
              element.link == location.pathname ||
              element.link.pathname == location.pathname
            )
              showActiveSub = true;
            return (
              <ListItem
                button
                className={`${classes.mobileDropdownList} ${
                  classes.navTextHoverMobile
                } ${classes.navBarTextContainer} ${
                  showActiveSub && classes.activeNavItem
                } ${classes.navLink}`}
                onClick={() => handleListItemClick(element)}
              >
                <ListItemText
                  primary={element.label}
                  style={{ color: theme?.agentTheme?.background?.primary_text }}
                />
              </ListItem>
            );
          })}
        </List>
      </Collapse>
    </>
  );
};

const Navbar_6_MwebInfo = ({ memberProfile }) => {
  const theme = useTheme();
  const classes = useStylesMobile();

  const footerObj = [
    {
      icon: <Phone />,
      header: "Call us at",
      type: "phone",
      content: memberProfile?.phone_numbers,
    },
    {
      icon: <Email />,
      header: "Write us at",
      type: "email",
      content: memberProfile?.emails,
    },
  ];
  const getContent = ({ type, content }) => {
    if (type === "phone") {
      return (
        <div>
          {content.map((item) => (
            <a href={`tel:+${item.phone_no}`}>
              <Typography color="textSecondary" className={classes.iconStyle}>
                +{item.phone_no}
              </Typography>
            </a>
          ))}
        </div>
      );
    } else if (type === "email") {
      return (
        <div>
          {content.map((item) => (
            <a href={`mailto:${item.email}`}>
              <Typography color="textSecondary" className={classes.iconStyle}>
                {item.email}
              </Typography>
            </a>
          ))}
        </div>
      );
    }
  };

  const contactInfo = () => (
    <ListItem
      style={{
        color: theme?.agentTheme?.background?.primary_text,

        paddingLeft: 0,
      }}
    >
      <ListItemText>
        <Box style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {footerObj.map((item) => (
            <Box display="flex" ml={1} mr={1}>
              <div className={classes.iconStyle}>{item.icon}</div>
              <Typography variant="body1" color="textSecondary">
                {getContent(item)}
              </Typography>
            </Box>
          ))}
        </Box>
      </ListItemText>
    </ListItem>
  );
  return [contactInfo];
};

export const StyledDrawer = withStyles((theme) => ({
  root: {
    position: "relative !important",
  },
  paperAnchorRight: {
    overflowY: "scroll",
    margin: "auto",
    alignItems: "baseline",
    padding: theme.spacing(2, 0),
    width: "180px",
    "&>*": {
      width: "100%",
    },
  },
  paperAnchorLeft: {
    margin: "auto",
    alignItems: "baseline",
    padding: theme.spacing(2, 0),
    width: "80vw",
    "&>*": {
      width: "100%",
    },
  },
}))((props) => <Drawer {...props} />);

export const MobileNavDrawer = ({
  contentArr,
  mobileNavBarOpen = true,
  setToggleMenu,
  username,
  handleListItemClick,
  logoutClick,
  componentType,
  memberProfile,
}) => {
  const theme = useTheme();
  const classes = useStylesMobile();
  const location = useLocation();
  const { isLoggedIn = false } = useContext(WebContext);
  const history = useHistory();

  const ComponentProps = {
    memberProfile,
  };
  const ComponentMap = {
    NAVBAR_6: Navbar_6_MwebInfo,
  };

  const getComponentFn = ComponentMap?.[componentType] || null;

  const [Comp1] = getComponentFn ? getComponentFn(ComponentProps) : [];

  return (
    <Collapse in={mobileNavBarOpen} timeout={"5000"}>
      <StyledDrawer
        anchor={"left"}
        open={mobileNavBarOpen}
        onClose={() => setToggleMenu(false)}
      >
        <ListItem button style={{ position: "relative" }}>
          <LoginButton loginClass={classes.loginButtonStyle} />
        </ListItem>
        {isLoggedIn && (
          <ListItem
            button
            style={{ color: theme?.agentTheme?.background?.primary_text }}
            onClick={() =>
              history.push(`/${username ? `${username}/` : ""}en/my_bookings`)
            }
          >
            <ListItemText primary={"My Bookings"} />
          </ListItem>
        )}
        <Divider
          style={{
            backgroundColor: theme?.agentTheme?.background?.primary_text,
            opacity: 0.5,
          }}
        />
        {Comp1 && <Comp1 />}
        {getMobileNavItem(
          classes,
          username,
          contentArr,
          location,
          handleListItemClick,
          theme
        )}
        {isLoggedIn && (
          <ListItem
            button
            style={{ position: "relative" }}
            onClick={() => logoutClick()}
          >
            <Box display={"flex"} flexDirection="row" alignItems={"center"}>
              <Box pr={1} alignItems="inherit">
                <img src={logoutpng0} />
              </Box>
              <Typography
                className={classes.logoutText}
                style={{ color: theme?.agentTheme?.background?.primary_text }}
              >
                Logout
              </Typography>
            </Box>
          </ListItem>
        )}
      </StyledDrawer>
    </Collapse>
  );
};

const StyledMenu = withStyles((theme) => ({
  paper: {
    border: `1px solid ${theme?.agentTheme?.background?.primary_text}`,
  },
}))((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({}))(MenuItem);

export const DesktopMenuDropdown = ({
  anchorEl = null,
  handleCovidMenuClose,
  clickItem = [],
  handleCovidMenuItemClick,
  loginMenu = false,
}) => {
  const classes = useStylesMobile();
  const theme = useTheme();
  const location = useLocation();

  return (
    <StyledMenu
      id="customized-menu"
      keepMounted
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleCovidMenuClose}
    >
      {clickItem.map((element, index) => {
        let showActiveSub = false;
        let { imgLink = false, link = "", id = "" } = element;
        if (link == location.pathname || link.pathname == location.pathname)
          showActiveSub = true;
        return (
          <StyledMenuItem
            key={index}
            onClick={(event) => handleCovidMenuItemClick(event, index, element)}
            className={`${classes.navTextHoverMobile} ${classes.navLink} ${
              showActiveSub && classes.activeNavItem
            }`}
            style={{ color: theme?.agentTheme?.background?.primary_text }}
          >
            {loginMenu ? (
              <div className={`${classes.loginMenuItems}`}>
                {imgLink && (
                  <Box pr={1}>
                    <img src={imgLink} />
                  </Box>
                )}
                <Typography noWrap={true}>{element.label || ""}</Typography>
              </div>
            ) : (
              element.label || ""
            )}
          </StyledMenuItem>
        );
      })}
    </StyledMenu>
  );
};
